module.exports = __webpack_public_path__ + "img/pd-right-delete.35ced859.svg";